module.exports = __webpack_public_path__ + "static/linkedlist-2.9-853455660e369cabe26df20d39d6ba58.png";